import { render, staticRenderFns } from "./TblBackups.vue?vue&type=template&id=fbf4f7c8&scoped=true&"
import script from "./TblBackups.vue?vue&type=script&lang=js&"
export * from "./TblBackups.vue?vue&type=script&lang=js&"
import style0 from "./TblBackups.vue?vue&type=style&index=0&id=fbf4f7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf4f7c8",
  null
  
)

export default component.exports